import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { supportTicketApi } from 'shared/services/supportTicketApi';
import { queryKeys } from '../queryConfig';

export interface SupportTicketsFilters {
  company?: string;
  status?: string;
  category?: string;
  severity?: string;
  page?: number;
  limit?: number;
}

export const useSupportTickets = (filters: SupportTicketsFilters = {}) => {
  const queryParams = {
    page: filters.page || 1,
    limit: filters.limit || 20,
    ...(filters.company && { company: filters.company }),
    ...(filters.status && { status: filters.status }),
    ...(filters.category && { category: filters.category }),
    ...(filters.severity && { severity: filters.severity }),
  };

  return useQuery({
    queryKey: queryKeys.supportTickets.list(queryParams, filters.company || ''),
    queryFn: () => supportTicketApi.getAll(queryParams),
    placeholderData: keepPreviousData,
  });
};

export const useSupportTicketStats = (company?: string) => {
  return useQuery({
    queryKey: queryKeys.supportTickets.stats(company || ''),
    queryFn: () => supportTicketApi.getStats({ company }),
  });
};

export const useDeleteSupportTicket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => supportTicketApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.supportTickets.all });
    },
  });
};
